/* AE Florida Trophy Builder — Variant E (Showcase), native Shopify wiring.
   Commerce model (locked): per-trophy-price variants; the customer enters a COUNT (how many
   trophies) and that count is the Shopify line quantity. The product has 3 real options —
   Quantity (tier "1"/"3+"/"6+"/"12+"/"24+") x Style ("<Column> <Tier>") x Price Class
   ("Standard"/"Premium"/"Deluxe") = 135 variants. Price Class is COMPUTED (max class of the
   chosen column/topper/base), never a customer dial. Components are line-item properties.

   Renders the catalog-driven option sets into the Variant E layout, computes per-trophy pricing
   from the resolved variant, keeps the engraving plate / sticky bar / summary rail / mobile dock
   in sync, writes line-item properties (incl. canonical _Component Handles), and submits the
   native product form. FEATURED components render inline; "More <role>" dispatches the browse
   drawer (aetb:browse-open) and the builder listens for aetb:browse-select. Falls back to demo
   data outside Shopify. Private catalog pricing is not read or emitted. */
(function () {
  "use strict";

  /* ---------- quantity-tier ladder ---------- */
  var FALLBACK_TIERS = [
    { id: "qty1", variantValue: "1", rate_qty: 1, min: 1, max: 1 },
    { id: "qty3", variantValue: "3+", rate_qty: 3, min: 3, max: 5, save_percent: 10 },
    { id: "qty6", variantValue: "6+", rate_qty: 6, min: 6, max: 11, save_percent: 12 },
    { id: "qty12", variantValue: "12+", rate_qty: 12, min: 12, max: 23, save_percent: 15 },
    { id: "qty24", variantValue: "24+", rate_qty: 24, min: 24, max: null, save_percent: 20 }
  ];

  var CLASS_RANK = { standard: 0, premium: 1, deluxe: 2 };

  /* ---------- fallback demo data (used only outside Shopify / before metaobjects exist) ---------- */
  function buildFallback() {
    var styleColumns = [
      { id: "single-column", handle: "single-column", label: "Single Column", variantValue: "Single Column", description: "One column under the figure.", image: "ae-style-single.png", sort_order: 1, enabled: true },
      { id: "double-column", handle: "double-column", label: "Double Column", variantValue: "Double Column", description: "Two columns, wider stance.", image: "ae-style-double.png", sort_order: 2, enabled: true }
    ];
    var styleTiers = [
      { id: "one-tier", handle: "one-tier", label: "1 Tier", variantValue: "1 Tier", description: "Classic single-level build.", image: "ae-style-tier1.png", sort_order: 1, enabled: true },
      { id: "two-tier", handle: "two-tier", label: "2 Tier", variantValue: "2 Tier", description: "Stacked two-level build.", image: "ae-style-twotier.png", sort_order: 2, enabled: true }
    ];
    return {
      version: "2026-06-13.fallback",
      moneyFormat: "${{amount}}",
      settings: { perTrophyNote: "Engraving & setup included", contactUrl: "/pages/contact" },
      quantity: { default: 12, min: 1, tiers: FALLBACK_TIERS },
      catalogUrl: "builder-catalog.json",
      style_columns: styleColumns,
      style_tiers: styleTiers,
      columns: [
        { id: "red-gold-buzzsaw", handle: "red-gold-buzzsaw", label: "Red/Gold Buzz Saw", swatch: "#ac1e23", price_class: "standard", image: "https://res.cloudinary.com/business-products/image/upload/e_trim/c_pad,b_white,h_820,w_340,q_auto/v1667523947/products/images/large/BZ701--48159a06.jpg", sort_order: 1, enabled: true, featured: true },
        { id: "blue-gold-buzzsaw", handle: "blue-gold-buzzsaw", label: "Blue/Gold Buzz Saw", swatch: "#064f92", price_class: "standard", image: "https://res.cloudinary.com/business-products/image/upload/e_trim/c_pad,b_white,h_820,w_340,q_auto/v1667523949/products/images/large/BZ702--bf38a81f.jpg", sort_order: 2, enabled: true, featured: true },
        { id: "green-gold-buzzsaw", handle: "green-gold-buzzsaw", label: "Green/Gold Buzz Saw", swatch: "#0a6b3d", price_class: "standard", image: "https://res.cloudinary.com/business-products/image/upload/e_trim/c_pad,b_white,h_820,w_340,q_auto/v1667523951/products/images/large/BZ703--ae1c52e8.jpg", sort_order: 3, enabled: true, featured: true },
        { id: "silver-gold-buzzsaw", handle: "silver-gold-buzzsaw", label: "Silver/Gold Buzz Saw", swatch: "#aab2bd", price_class: "premium", image: "https://res.cloudinary.com/business-products/image/upload/e_trim/c_pad,b_white,h_820,w_340,q_auto/v1667523955/products/images/large/BZ705--706d922e.jpg", sort_order: 4, enabled: true, featured: true },
        { id: "gold-gold-buzzsaw", handle: "gold-gold-buzzsaw", label: "Gold/Gold Buzz Saw", swatch: "#c9942e", price_class: "premium", image: "https://res.cloudinary.com/business-products/image/upload/e_trim/c_pad,b_white,h_820,w_340,q_auto/v1667523957/products/images/large/BZ706--f7edde94.jpg", sort_order: 5, enabled: true, featured: true },
        { id: "usa-flag-column", handle: "usa-flag-column", label: "USA Flag", swatch: "#1a3a6b", price_class: "deluxe", image: "https://res.cloudinary.com/business-products/image/upload/e_trim/c_pad,b_white,h_820,w_340,q_auto/v1667557515/products/images/large/TW159A--e3682efa.jpg", sort_order: 6, enabled: true, featured: true }
      ],
      toppers: [
        { id: "basketball-action", handle: "basketball-action", label: "Basketball Action", category: "Basketball", price_class: "standard", image: "https://res.cloudinary.com/business-products/image/upload/e_trim/c_pad,b_white,h_680,w_520,q_auto/v1667549319/products/images/large/RP92846--29f685b0.jpg", sort_order: 1, enabled: true, featured: true },
        { id: "soccer-action", handle: "soccer-action", label: "Soccer Action", category: "Soccer", price_class: "standard", image: "https://res.cloudinary.com/business-products/image/upload/e_trim/c_pad,b_white,h_680,w_520,q_auto/v1667549317/products/images/large/RP92836--0ca4595d.jpg", sort_order: 2, enabled: true, featured: true },
        { id: "baseball-spinner", handle: "baseball-spinner", label: "Baseball Star Spinner", category: "Spinning", price_class: "premium", image: "https://res.cloudinary.com/business-products/image/upload/e_trim/c_pad,b_white,h_680,w_520,q_auto/v1667555234/products/images/large/SPN201--3dcf7c7d.jpg", sort_order: 3, enabled: true, featured: true },
        { id: "football-action", handle: "football-action", label: "Football Action", category: "Football", price_class: "standard", image: "https://res.cloudinary.com/business-products/image/upload/e_trim/c_pad,b_white,h_680,w_520,q_auto/v1667549326/products/images/large/RP92896--55ab41c6.jpg", sort_order: 4, enabled: true, featured: true },
        { id: "cheer-action", handle: "cheer-action", label: "Cheer Action", category: "Cheer", price_class: "standard", image: "https://res.cloudinary.com/business-products/image/upload/e_trim/c_pad,b_white,h_680,w_520,q_auto/v1667549322/products/images/large/RP92876--e873571a.jpg", sort_order: 5, enabled: true, featured: true },
        { id: "dance-spinner", handle: "dance-spinner", label: "Dance Star Spinner", category: "Dance and Pageant", price_class: "premium", image: "https://res.cloudinary.com/business-products/image/upload/e_trim/c_pad,b_white,h_680,w_520,q_auto/v1718392600/products/images/large/SPN206--8a497ab8.png", sort_order: 6, enabled: true, featured: true },
        { id: "volleyball-profile", handle: "volleyball-profile", label: "Volleyball Profile", category: "Volleyball", price_class: "standard", image: "https://res.cloudinary.com/business-products/image/upload/e_trim/c_pad,b_white,h_680,w_520,q_auto/v1667549019/products/images/large/RP90865--f6416b19.jpg", sort_order: 7, enabled: true, featured: true },
        { id: "gold-star-action", handle: "gold-star-action", label: "Gold Star Action", category: "Star", price_class: "standard", image: "https://res.cloudinary.com/business-products/image/upload/e_trim/c_pad,b_white,h_680,w_520,q_auto/v1667549254/products/images/large/RP92566--a9e5716e.jpg", sort_order: 8, enabled: true, featured: true }
      ],
      bases: [
        { id: "black-slant-marble", handle: "black-slant-marble", label: "Black Slant Marble", finish: "Black marble", price_class: "standard", image: "ae-base-blackmarble.png", sort_order: 1, enabled: true, featured: true },
        { id: "white-slant-marble", handle: "white-slant-marble", label: "White Slant Marble", finish: "White marble", price_class: "standard", image: "ae-base-whitemarble.png", sort_order: 2, enabled: true, featured: true },
        { id: "black-round-plastic", handle: "black-round-plastic", label: "Black Round (Budget)", finish: "Weighted plastic", price_class: "standard", image: "ae-base-plastic.png", sort_order: 3, enabled: true, featured: true },
        { id: "square-rosewood", handle: "square-rosewood", label: "Square Rosewood Piano", finish: "Rosewood piano finish", price_class: "premium", image: "ae-base-rosewood.png", sort_order: 4, enabled: true, featured: true }
      ],
      logo_insert: { handle: "RP91576", label: "Custom Logo Insert", price_class: "standard", image: "" },
      product: { optionNames: ["Quantity", "Style", "Price Class"], variants: [] }
    };
  }

  var FALLBACK_DATA = buildFallback();

  function escapeHTML(v) {
    return String(v == null ? "" : v).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  }
  function normalize(v) { return String(v == null ? "" : v).trim().toLowerCase(); }
  function capitalize(v) { v = String(v == null ? "" : v).trim(); return v ? v.charAt(0).toUpperCase() + v.slice(1).toLowerCase() : v; }
  function enabledOnly(items) { return (items || []).filter(function (i) { return i && i.enabled !== false; }); }
  function bySort(items) {
    return enabledOnly(items).slice().sort(function (a, b) { return Number(a.sort_order || 0) - Number(b.sort_order || 0); });
  }
  function featuredOnly(items) {
    var feat = (items || []).filter(function (i) { return i && i.featured; });
    return feat.length ? feat : (items || []);
  }
  function findById(items, id) {
    return (items || []).find(function (i) { return String(i.id || i.handle) === String(id); }) || null;
  }
  function firstEnabled(items) { return bySort(items)[0] || null; }
  function variantAvailable(variant) { return Boolean(variant && variant.available !== false); }
  function money(cents, format) {
    var amount = (Number(cents || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return String(format || "${{amount}}").replace("{{amount}}", amount).replace("{{ amount }}", amount);
  }
  function mediumColumnLabel(label) {
    return String(label || "")
      .replace(/^\s*\d+(?:\s*\d+\/\d+)?\"?\s+/i, "")
      .replace(/\bRectanglular\b/gi, "Rectangular")
      .replace(/\s+Trophy Column\b/gi, "")
      .replace(/\s+Column\b/gi, "")
      .replace(/\s{2,}/g, " ")
      .trim();
  }
  function normalizeColumnShape(value) {
    var s = String(value || "");
    if (/rectang/i.test(s)) return "Rectangular";
    if (/\bround\b/i.test(s)) return "Round";
    if (/oval|other/i.test(s)) return "Oval/Other";
    return "";
  }
  function columnShape(item) {
    return normalizeColumnShape(item && item.shape) || normalizeColumnShape(item && item.label) || "Oval/Other";
  }
  function columnColorLabel(item) {
    if (item && item.display_label) return String(item.display_label);
    var shortLabel = mediumColumnLabel(item && item.label);
    var cleaned = shortLabel
      .replace(/\b(Rectangular|Round|Oval)\b/gi, "")
      .replace(/\b(Buzz Saw|Twist|Sport)\b/gi, "")
      .replace(/\s{2,}/g, " ")
      .trim();
    return cleaned || shortLabel || (item && item.handle) || "";
  }
  function columnLabelParts(item) {
    var shape = columnShape(item);
    return {
      main: columnColorLabel(item),
      detail: shape + " column",
      shape: shape
    };
  }
  function mediumTopperLabel(label) {
    return String(label || "")
      .replace(/\s+Action Figure\b/gi, " Figure")
      .replace(/\s+Action\b/gi, "")
      .replace(/\s{2,}/g, " ")
      .trim();
  }
  function mediumBaseLabel(label) {
    return String(label || "")
      .replace(/\s+Countersunk\b/gi, "")
      .replace(/\s+Weighted Plastic\b/gi, "")
      .replace(/\s+(Lid|Base)\b/gi, "")
      .replace(/\s{2,}/g, " ")
      .trim();
  }
  function displayComponentLabel(item, role) {
    if (!item) return "";
    if (role === "columns") return columnColorLabel(item) + " - " + columnShape(item) + " column";
    if (role === "bases") return item.display_label || mediumBaseLabel(item.label) || item.label;
    if (role === "toppers") return item.display_label || mediumTopperLabel(item.label) || item.label;
    return item.display_label || item.label || "";
  }

  var CATALOG_ROLES = { columns: true, toppers: true, bases: true };
  function normalizeCatalogItem(item, role) {
    var handle = item && (item.handle || item.id);
    handle = handle == null ? "" : String(handle).trim();
    if (!handle) return null;
    var out = {
      id: handle,
      handle: handle,
      label: item.label || handle,
      image: item.image || "",
      price_class: normalize(item.price_class) || "standard",
      featured: item.featured === true,
      sort_order: Number(item.sort_order || 0),
      enabled: item.enabled !== false
    };
    if (item.display_label) out.display_label = item.display_label;
    if (item.drawer_group) out.drawer_group = item.drawer_group;
    if (item.group) out.group = item.group;
    if (role === "columns") {
      out.swatch = item.swatch || "";
      out.shape = columnShape(item);
    }
    if (role === "bases") out.finish = item.finish || "";
    if (role === "toppers") out.category = item.category || "";
    return out;
  }
  function normalizeCatalogList(items, role) {
    return (items || []).map(function (item) { return normalizeCatalogItem(item, role); }).filter(Boolean);
  }
  function normalizeLogoInsert(item) {
    if (!item) return null;
    var handle = item.handle || item.id;
    handle = handle == null ? "" : String(handle).trim();
    if (!handle) return null;
    return {
      id: handle,
      handle: handle,
      label: item.label || "Custom Logo Insert",
      image: item.image || "",
      price_class: normalize(item.price_class) || "standard",
      enabled: true,
      featured: false
    };
  }
  function applyCatalogData(data, catalog) {
    if (!data || !catalog) return data;
    data._catalog = catalog;
    ["columns", "bases", "toppers"].forEach(function (role) {
      if (Array.isArray(catalog[role])) data[role] = normalizeCatalogList(catalog[role], role);
    });
    var logo = normalizeLogoInsert(catalog.logo_insert);
    if (logo) data.logo_insert = logo;
    return data;
  }
  function fetchCatalogForData(data) {
    if (!data || !data.catalogUrl || typeof fetch !== "function") return Promise.resolve(null);
    return fetch(data.catalogUrl, { credentials: "same-origin" })
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return null; });
  }

  function parseData(root) {
    var script = root.querySelector("[data-ae-builder-data]");
    if (!script) return JSON.parse(JSON.stringify(FALLBACK_DATA));
    try {
      var data = JSON.parse(script.textContent || "{}");
      var merged = JSON.parse(JSON.stringify(FALLBACK_DATA));
      Object.keys(data || {}).forEach(function (key) {
        if (Array.isArray(data[key])) { merged[key] = (data[key].length || CATALOG_ROLES[key]) ? data[key] : merged[key]; }
        else if (data[key] && typeof data[key] === "object") { merged[key] = Object.assign({}, merged[key] || {}, data[key]); }
        else if (data[key] != null && data[key] !== "") { merged[key] = data[key]; }
      });
      // when on a real product, prefer its real variants even if empty fallback exists
      if (data.product && Array.isArray(data.product.variants) && data.product.variants.length) {
        merged.product = Object.assign({}, merged.product, data.product);
      }
      return merged;
    } catch (e) {
      console.warn("AE trophy builder data failed to parse.", e);
      return JSON.parse(JSON.stringify(FALLBACK_DATA));
    }
  }

  function Builder(root, initialData) {
    this.root = root;
    this.form = root.querySelector("[data-ae-builder-form]") || root.querySelector(".ae-trophy-builder__form");
    this.data = initialData || parseData(root);
    this._catalog = this.data._catalog || null;
    this.money = this.data.moneyFormat;
    var qcfg = this.data.quantity || {};
    this.tiers = (qcfg.tiers && qcfg.tiers.length ? qcfg.tiers : FALLBACK_TIERS).slice();
    this.minCount = Math.max(1, Number(qcfg.min || 1));
    this.styleColumns = bySort(this.data.style_columns);
    this.styleTiers = bySort(this.data.style_tiers);
    // catalog roles: featured subset rendered inline; full list lives in builder-catalog.json
    this.columns = bySort(this.data.columns);
    this.bases = bySort(this.data.bases);
    this.toppers = bySort(this.data.toppers);
    this.logoInsert = this.data.logo_insert || null;
    // selection maps keep handles found via the browse drawer (not in the featured subset)
    this.extra = { columns: {}, toppers: {}, bases: {} };
    var defCount = Number(qcfg.default || 12);
    if (!isFinite(defCount) || defCount < this.minCount) defCount = this.minCount;
    this.state = {
      count: Math.round(defCount),
      styleColsId: (firstEnabled(this.styleColumns) || {}).id,
      styleTiersId: (firstEnabled(this.styleTiers) || {}).id,
      columnId: (firstEnabled(this.columns) || {}).id,
      topperId: (firstEnabled(this.toppers) || {}).id,
      baseId: (firstEnabled(this.bases) || {}).id,
      logoActive: false,
      specialColumnDesigns: false,
      engravingMode: "same",
      valid: false,
      variantId: ""
    };
    this.renderedEngravingCount = null;
    this.renderedEngravingMode = null;
    this.activeEngravingRow = 1;
    this.sets = [];
    this.submittingSets = false;
    this.init();
  }

  Builder.prototype.init = function () {
    this.renderQuantity();
    this.renderCards("style_columns", this.styleColumns, "styleColsId", this.styleCard.bind(this), "aetb-style");
    this.renderCards("style_tiers", this.styleTiers, "styleTiersId", this.styleCard.bind(this), "aetb-style");
    this.renderRole("columns");
    this.renderRole("toppers");
    this.renderRole("bases");
    this.bindFields();
    this.bindSpecialColumns();
    this.bindEngravingMode();
    this.bindEngravingTools();
    this.bindCount();
    this.bindBrowse();
    this.bindLogo();
    this.bindHero();
    this.bindNav();
    this.bindSets();
    this.bindSubmit();
    this.update();
  };

  /* ---------- count -> tier -> variant ---------- */
  Builder.prototype.tierForCount = function (n) {
    n = Math.max(this.minCount, Math.round(Number(n) || this.minCount));
    var tiers = this.tiers;
    // Match the band that contains n; otherwise clamp DOWN to the highest band whose
    // min <= n. This keeps >24 -> "24+" (last band has the highest min <= n) WITHOUT
    // letting an interior gap (e.g. count=2, which falls between the "1" and "3+" bands)
    // fall through to the deepest 24+ bulk rate. count=2 -> the "1" band (single rate).
    var fallback = tiers[0] || null;
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      var min = Number(t.min);
      var max = t.max == null ? Infinity : Number(t.max);
      if (n >= min && n <= max) return t;
      if (n >= min) fallback = t;
    }
    return fallback;
  };

  // chosenClass = max(rank) over the selected column/topper/base price_class
  Builder.prototype.chosenClass = function (sel) {
    sel = sel || this.selected();
    var parts = [sel.column, sel.topper, sel.base];
    var best = "standard", bestRank = -1;
    parts.forEach(function (p) {
      var cls = normalize(p && p.price_class) || "standard";
      var rank = CLASS_RANK[cls];
      // Clamp any unknown/typo class to standard so it can never resolve to a
      // non-existent variant and silently blank the id.
      if (rank == null) { cls = "standard"; rank = 0; }
      if (rank > bestRank) { bestRank = rank; best = cls; }
    });
    return best; // lowercase: "standard" | "premium" | "deluxe"
  };

  // Resolve the variant by [qtyTierValue, "<Column> <Tier>", capitalize(class)] against product.variants.
  Builder.prototype.variantFor = function (count, styleColsId, styleTiersId, chosenClass) {
    var tier = this.tierForCount(count);
    var sc = findById(this.styleColumns, styleColsId);
    var st = findById(this.styleTiers, styleTiersId);
    var variants = (this.data.product && this.data.product.variants) || [];
    if (!variants.length || !tier) return null;
    var qtyValue = tier.variantValue;                                   // "1" | "3+" | ...
    var styleValue = (sc && st) ? (sc.variantValue + " " + st.variantValue) : null; // "Single Column 1 Tier"
    var classValue = capitalize(chosenClass || "standard");              // "Standard" | "Premium" | "Deluxe"
    var optionNames = ((this.data.product && this.data.product.optionNames) || []).map(normalize);
    var qIndex = optionNames.indexOf("quantity");
    var sIndex = optionNames.indexOf("style");
    var cIndex = optionNames.indexOf("price class");
    if (optionNames.length) {
      if (qIndex < 0 || sIndex < 0 || cIndex < 0) return null;
      return variants.find(function (v) {
        var o = v.options || [v.option1, v.option2, v.option3];
        return normalize(o[qIndex]) === normalize(qtyValue) &&
          (!styleValue || normalize(o[sIndex]) === normalize(styleValue)) &&
          normalize(o[cIndex]) === normalize(classValue);
      }) || null;
    }
    var match = variants.find(function (v) {
      var o = v.options || [v.option1, v.option2, v.option3];
      var hasQ = o.some(function (x) { return normalize(x) === normalize(qtyValue); });
      var hasS = !styleValue || o.some(function (x) { return normalize(x) === normalize(styleValue); });
      var hasC = o.some(function (x) { return normalize(x) === normalize(classValue); });
      return hasQ && hasS && hasC;
    });
    return match || null;
  };

  // per-trophy cents for a given count + the current style + class
  Builder.prototype.perTrophyCents = function (count, chosenClass) {
    var v = this.variantFor(count, this.state.styleColsId, this.state.styleTiersId, chosenClass);
    return v ? v.price : null;   // variant price IS the per-trophy price
  };
  Builder.prototype.singlePerTrophy = function (chosenClass) {
    return this.perTrophyCents(1, chosenClass);
  };

  Builder.prototype.tierSavePercent = function (tier) {
    var raw = tier && (tier.save_percent != null ? tier.save_percent : tier.savePercent);
    var n = Number(raw || 0);
    return isFinite(n) && n > 0 ? Math.round(n) : 0;
  };

  Builder.prototype.tierLabel = function (tier) {
    if (!tier) return "";
    return tier.max == null
      ? (tier.min + "+ trophies")
      : (tier.min === tier.max ? (tier.min === 1 ? "1 trophy" : tier.min + " trophies") : (tier.min + "-" + tier.max + " trophies"));
  };

  Builder.prototype.tierSaveLabel = function (tier) {
    var save = this.tierSavePercent(tier);
    return save > 0 ? "Save " + save + "%" : "";
  };

  /* ---------- QUANTITY: count entry + tier ladder ---------- */
  Builder.prototype.renderQuantity = function () {
    var container = this.root.querySelector('[data-ae-options="counts"]');
    if (!container) return;
    var self = this;
    var cls = this.chosenClass();
    var activeTier = this.tierForCount(this.state.count);
    container.innerHTML = this.tiers.map(function (t) {
      // representative count for this tier = its min (the rate kicks in at min)
      var per = self.perTrophyCents(t.min, cls);
      var on = activeTier && String(activeTier.id) === String(t.id) ? " on" : "";
      var perTxt = per != null ? money(per, self.money) : "—";
      var saveTxt = self.tierSaveLabel(t);
      var label = t.max == null ? (t.min + "+ trophies") : (t.min === t.max ? (t.min === 1 ? "1 trophy" : t.min + " trophies") : (t.min + "–" + t.max + " trophies"));
      return '<button type="button" class="aetb-qrow' + on + '" data-ae-tier="' + escapeHTML(t.id) + '" aria-pressed="' + (on ? "true" : "false") + '">' +
        '<span class="aetb-qr"><b>' + escapeHTML(t.variantValue) + '</b> · ' + escapeHTML(label) + '</span>' +
        '<span class="aetb-qp">' + perTxt + '<span style="font:inherit;font-size:11px;color:var(--aetb-muted);font-weight:600"> ea</span></span>' +
        '<span class="aetb-qs">' + saveTxt + '</span>' +
      '</button>';
    }).join("");
  };

  /* ---------- generic card renderer (styles) ---------- */
  Builder.prototype.renderCards = function (target, items, key, cardFn, cls) {
    var container = this.root.querySelector('[data-ae-options="' + target + '"]');
    if (!container) return;
    var self = this;
    container.innerHTML = items.map(function (item) {
      var id = escapeHTML(item.id || item.handle);
      var on = String(self.state[key]) === String(item.id || item.handle) ? " on" : "";
      return '<button type="button" class="' + cls + on + '" data-ae-select="' + escapeHTML(key) + '" data-ae-value="' + id + '">' + cardFn(item) + "</button>";
    }).join("");
    if (!container.__bound) {
      container.__bound = true;
      container.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-ae-select]");
        if (!btn) return;
        self.state[btn.getAttribute("data-ae-select")] = btn.getAttribute("data-ae-value");
        self.update();
      });
    }
  };

  /* ---------- catalog roles (featured inline + "More" -> browse drawer) ---------- */
  // roleConfig maps the section role to its state key, list, card fn and css class.
  Builder.prototype.roleConfig = function (role) {
    var map = {
      columns: { key: "columnId", list: "columns", cardFn: this.columnCard, cls: "aetb-strip" },
      toppers: { key: "topperId", list: "toppers", cardFn: this.topperCard, cls: "aetb-fig" },
      bases: { key: "baseId", list: "bases", cardFn: this.baseCard, cls: "aetb-slab" }
    };
    return map[role];
  };
  Builder.prototype.renderRole = function (role) {
    var cfg = this.roleConfig(role);
    if (!cfg) return;
    var container = this.root.querySelector('[data-ae-options="' + role + '"]');
    if (!container) return;
    var self = this;
    var pool = featuredOnly(this[cfg.list]).slice();
    var selId = this.state[cfg.key];
    var items = pool.slice(0, 5);
    // Keep a browse-drawer pick visible on the front grid, then reserve tile six for browsing.
    if (selId && !items.some(function (i) { return String(i.id || i.handle) === String(selId); })) {
      var selected = pool.find(function (i) { return String(i.id || i.handle) === String(selId); }) || this.extra[role][selId];
      if (selected) {
        items = [selected].concat(pool.filter(function (i) { return String(i.id || i.handle) !== String(selId); })).slice(0, 5);
      }
    }
    var cardFn = cfg.cardFn.bind(this);
    container.innerHTML = items.map(function (item) {
      var id = escapeHTML(item.id || item.handle);
      var on = String(self.state[cfg.key]) === String(item.id || item.handle) ? " on" : "";
      var label = escapeHTML(item.label || "");
      return '<button type="button" class="' + cfg.cls + on + '" data-ae-select="' + cfg.key + '" data-ae-value="' + id + '" title="' + label + '">' + cardFn(item) + "</button>";
    }).join("") + this.browseCard(role, cfg.cls, items);
    if (!container.__bound) {
      container.__bound = true;
      container.addEventListener("click", function (e) {
        var browse = e.target.closest("[data-ae-browse]");
        if (browse) {
          self.openBrowse(browse.getAttribute("data-ae-browse"));
          return;
        }
        var btn = e.target.closest("[data-ae-select]");
        if (!btn) return;
        self.state[cfg.key] = btn.getAttribute("data-ae-value");
        self.update();
      });
    }
  };

  Builder.prototype.browseCard = function (role, cls, visibleItems) {
    var copy = {
      columns: { title: "More columns", note: "Browse every color" },
      toppers: { title: "More figures", note: "Browse every sport" },
      bases: { title: "Base options", note: "Choose a simple base" }
    }[role] || { title: "More options", note: "Browse all choices" };
    var tile = (this.data.browseTiles && this.data.browseTiles[role]) || {};
    var referenceItem = visibleItems && visibleItems.length ? visibleItems[visibleItems.length - 1] : null;
    var mediaClass = { columns: "aetb-tall", toppers: "aetb-stand", bases: "aetb-low" }[role] || "aetb-stand";
    var useReferenceImage = role === "columns" || role === "bases";
    var imageUrl = (useReferenceImage && referenceItem && referenceItem.image) || tile.image;
    var image = imageUrl ? '<img src="' + escapeHTML(imageUrl) + '" alt="" loading="lazy">' : '<span class="aetb-browse-mark">?</span>';
    return '<button type="button" class="' + cls + ' aetb-browse-card" data-ae-browse="' + escapeHTML(role) + '" aria-label="' + escapeHTML(copy.title) + '">' +
      '<span class="' + mediaClass + ' aetb-browse-art aetb-browse-art--' + escapeHTML(role) + '" aria-hidden="true">' +
        image +
      '</span><span class="aetb-nm aetb-browse-copy"><b>' + escapeHTML(copy.title) + '</b><span>' + escapeHTML(copy.note) + "</span></span></button>";
  };

  Builder.prototype.styleCard = function (item) {
    var img = item.image ? '<img src="' + escapeHTML(item.image) + '" alt="' + escapeHTML(item.label) + '">' : "";
    return '<span class="aetb-ph">' + img + '</span><span class="aetb-tx"><b>' + escapeHTML(item.label) + "</b>" +
      (item.description ? "<span>" + escapeHTML(item.description) + "</span>" : "") + "</span>";
  };
  Builder.prototype.columnCard = function (item) {
    var img = item.image ? '<img src="' + escapeHTML(item.image) + '" alt="">' : "";
    var label = columnLabelParts(item);
    return '<span class="aetb-tall">' + img + '</span><span class="aetb-nm aetb-col-label"><b><span class="aetb-col-main">' +
      escapeHTML(label.main) + '</span>' +
      (label.detail ? '<span class="aetb-col-detail">' + escapeHTML(label.detail) + '</span>' : "") +
      "</b></span>";
  };
  Builder.prototype.topperCard = function (item) {
    var img = item.image ? '<img src="' + escapeHTML(item.image) + '" alt="" loading="lazy">' : escapeHTML(item.emoji || "");
    return '<span class="aetb-stand">' + img + '</span><span class="aetb-nm"><b>' + escapeHTML(mediumTopperLabel(item.label)) + "</b></span>";
  };
  Builder.prototype.baseCard = function (item) {
    var img = item.image ? '<img src="' + escapeHTML(item.image) + '" alt="">' : "";
    var label = item.display_label || mediumBaseLabel(item.label);
    return '<span class="aetb-low">' + img + '</span><span class="aetb-nm"><b>' + escapeHTML(label) + "</b></span>";
  };

  /* ---------- count input (number entry + stepper) ---------- */
  Builder.prototype.bindCount = function () {
    var self = this;
    var input = this.root.querySelector("[data-ae-count-input]");
    if (input) {
      var commit = function () {
        var n = Math.round(Number(input.value) || self.minCount);
        if (!isFinite(n) || n < self.minCount) n = self.minCount;
        self.state.count = n;
        self.update();
      };
      input.addEventListener("input", function () {
        var n = Math.round(Number(input.value));
        if (isFinite(n) && n >= self.minCount) { self.state.count = n; self.update(); }
      });
      input.addEventListener("change", commit);
      input.addEventListener("blur", commit);
    }
    this.root.querySelectorAll("[data-ae-qty-step]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var dir = Number(btn.getAttribute("data-ae-qty-step"));
        self.state.count = Math.max(self.minCount, self.state.count + dir);
        self.update();
      });
    });
    // ladder rows: clicking a tier jumps the count to that tier's representative min
    var ladder = this.root.querySelector('[data-ae-options="counts"]');
    if (ladder && !ladder.__bound) {
      ladder.__bound = true;
      ladder.addEventListener("click", function (e) {
        var row = e.target.closest("[data-ae-tier]");
        if (!row) return;
        var tier = findById(self.tiers, row.getAttribute("data-ae-tier"));
        if (tier) { self.state.count = Math.max(self.minCount, Number(tier.min) || self.minCount); self.update(); }
      });
    }
  };

  /* ---------- browse drawer hooks (event-decoupled from aetb-browse.js) ---------- */
  Builder.prototype.bindBrowse = function () {
    var self = this;
    // role of each "More" button: data-ae-browse="columns|toppers|bases"
    this.root.querySelectorAll("[data-ae-browse]").forEach(function (btn) {
      if (btn.closest("[data-ae-options]")) return;
      btn.addEventListener("click", function () {
        self.openBrowse(btn.getAttribute("data-ae-browse"));
      });
    });
    // the drawer reports a pick; set the selection exactly like a featured card.
    // The browse module emits {role, handle} only, so we resolve the catalog entry ourselves.
    document.addEventListener("aetb:browse-select", function (e) {
      var detail = (e && e.detail) || {};
      if (!detail.role || !detail.handle) return;
      if (detail.item && detail.item.handle) {
        self.selectFromBrowse(detail.role, detail.handle, detail.item);
        return;
      }
      self.resolveCatalogItem(detail.role, detail.handle).then(function (item) {
        if (!item) {
          self.setError("That component could not be loaded. Please choose another option.");
          return;
        }
        self.selectFromBrowse(detail.role, detail.handle, item);
      });
    });
  };

  Builder.prototype.openBrowse = function (role) {
    var cfg = this.roleConfig(role);
    var currentHandle = cfg ? this.state[cfg.key] : null;
    document.dispatchEvent(new CustomEvent("aetb:browse-open", { detail: { role: role, currentHandle: currentHandle } }));
  };

  // Lazily fetch builder-catalog.json (cached) so a non-featured browse pick can be rendered
  // and resolved without depending on the browse module to pass the item.
  Builder.prototype.fetchCatalog = function () {
    if (this._catalog) return Promise.resolve(this._catalog);
    if (this._catalogPromise) return this._catalogPromise;
    var url = this.data.catalogUrl || "builder-catalog.json";
    if (typeof fetch !== "function") { this._catalogPromise = Promise.resolve(null); return this._catalogPromise; }
    var self = this;
    this._catalogPromise = fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cat) {
        if (cat) {
          self._catalog = cat;
          applyCatalogData(self.data, cat);
        }
        return cat;
      })
      .catch(function () { self._catalogPromise = null; return null; });
    return this._catalogPromise;
  };
  // role -> catalog array key
  Builder.prototype.catalogKeyFor = function (role) {
    return { columns: "columns", toppers: "toppers", bases: "bases" }[role] || role;
  };
  Builder.prototype.resolveCatalogItem = function (role, handle) {
    var self = this;
    // already known (featured or previously fetched) — skip the fetch
    var cfg = this.roleConfig(role);
    if (cfg && findById(this[cfg.list], handle)) return Promise.resolve(findById(this[cfg.list], handle));
    return this.fetchCatalog().then(function (cat) {
      if (!cat) return null;
      var arr = cat[self.catalogKeyFor(role)] || [];
      return arr.find(function (i) { return String(i.handle) === String(handle); }) || null;
    });
  };

  // Apply a browse pick. `item` (optional) is the catalog entry so we can render its card even
  // though it isn't in the featured subset.
  Builder.prototype.selectFromBrowse = function (role, handle, item) {
    var cfg = this.roleConfig(role);
    if (!cfg) return;
    if (!item && !findById(this[cfg.list], handle)) {
      this.setError("That component could not be loaded. Please choose another option.");
      return;
    }
    if (item && (item.handle || item.id)) {
      var h = item.handle || item.id;
      var normItem = {
        id: h, handle: h, label: item.label, image: item.image,
        price_class: item.price_class || "standard", category: item.category, finish: item.finish,
        swatch: item.swatch, display_label: item.display_label, drawer_group: item.drawer_group,
        group: item.group, shape: role === "columns" ? columnShape(item) : item.shape,
        sort_order: 0, enabled: true, featured: false
      };
      this.extra[role][handle] = normItem;
      // make it resolvable by findById for the rest of the pass
      if (!findById(this[cfg.list], handle)) this[cfg.list] = this[cfg.list].concat([normItem]);
    }
    this.state[cfg.key] = handle;
    if (role === "toppers" && this.logoInsert && handle !== this.logoInsert.handle) this.state.logoActive = false;
    this.renderRole(role);
    this.update();
  };

  /* ---------- logo insert (featured card -> reveals artwork upload) ---------- */
  Builder.prototype.bindLogo = function () {
    var self = this;
    var card = this.root.querySelector("[data-ae-logo-card]");
    if (card) {
      card.addEventListener("click", function () {
        if (!self.logoInsert) return;
        self.state.topperId = self.logoInsert.handle;
        self.state.logoActive = true;
        // register the logo insert as a selectable topper so it resolves + renders
        if (!findById(self.toppers, self.logoInsert.handle)) {
          var li = { id: self.logoInsert.handle, handle: self.logoInsert.handle, label: self.logoInsert.label, image: self.logoInsert.image, price_class: self.logoInsert.price_class || "standard", category: "Logo", sort_order: 0, enabled: true, featured: false };
          self.extra.toppers[self.logoInsert.handle] = li;
          self.toppers = self.toppers.concat([li]);
        }
        self.renderRole("toppers");
        self.update();
      });
    }
  };
  Builder.prototype.updateLogo = function (sel) {
    var wrap = this.root.querySelector("[data-ae-logo-upload]");
    var active = this.logoInsert && sel.topper && String(sel.topper.handle || sel.topper.id) === String(this.logoInsert.handle);
    this.state.logoActive = Boolean(active);
    if (wrap) wrap.hidden = !active;
    var card = this.root.querySelector("[data-ae-logo-card]");
    if (card) card.classList.toggle("on", Boolean(active));
  };

  /* ---------- fields, hero gallery, nav ---------- */
  Builder.prototype.getField = function (name) {
    var el = this.root.querySelector('[data-ae-field="' + name + '"]');
    return el ? String(el.value || "").trim() : "";
  };
  Builder.prototype.sameEngravingFields = function () {
    return {
      line1: this.getField("line1"),
      line2: this.getField("line2"),
      line3: this.getField("line3")
    };
  };
  Builder.prototype.getEngravingRows = function () {
    var rows = [];
    this.root.querySelectorAll("[data-ae-engraving-row]").forEach(function (row) {
      var idx = Number(row.getAttribute("data-ae-engraving-row")) || rows.length + 1;
      var get = function (field) {
        var el = row.querySelector('[data-ae-row-field="' + field + '"]');
        return el ? String(el.value || "").trim() : "";
      };
      rows.push({ trophy: idx, line1: get("line1"), line2: get("line2"), line3: get("line3") });
    });
    rows.sort(function (a, b) { return a.trophy - b.trophy; });
    return rows;
  };
  Builder.prototype.syncEngravingModeUI = function () {
    var mode = this.state.engravingMode === "different" ? "different" : "same";
    var same = this.root.querySelector("[data-ae-same-engraving]");
    var diff = this.root.querySelector("[data-ae-different-engraving]");
    this.root.querySelectorAll("[data-ae-engraving-mode]").forEach(function (input) {
      input.checked = input.value === mode;
      var label = input.closest(".aetb-eng-mode");
      if (label) label.classList.toggle("on", input.checked);
    });
    if (same) same.hidden = mode !== "same";
    if (diff) diff.hidden = mode !== "different";
  };
  Builder.prototype.renderEngravingRows = function () {
    this.syncEngravingModeUI();
    var mode = this.state.engravingMode === "different" ? "different" : "same";
    if (mode !== "different") {
      this.renderedEngravingMode = mode;
      return;
    }
    var mount = this.root.querySelector("[data-ae-engraving-list]");
    if (!mount) return;
    var count = Math.max(this.minCount || 1, Number(this.state.count) || 1);
    var countLabel = this.root.querySelector("[data-ae-engraving-count]");
    if (countLabel) countLabel.textContent = count + " trophy plates";
    if (this.renderedEngravingCount === count && this.renderedEngravingMode === mode) return;
    var oldRows = this.getEngravingRows();
    var byIndex = {};
    oldRows.forEach(function (row) { byIndex[row.trophy] = row; });
    var html = '<div class="aetb-engraving-table-head" aria-hidden="true">' +
      '<span>#</span><span>Line 1 / name</span><span>Line 2 / award</span><span>Line 3 (optional)</span><span>Plate preview</span>' +
    "</div>";
    for (var i = 1; i <= count; i++) {
      var old = byIndex[i] || {};
      html += '<div class="aetb-engraving-row" data-ae-engraving-row="' + i + '">' +
        '<div class="aetb-engraving-row-index"><span>' + i + '</span><b>Trophy ' + i + "</b></div>" +
        '<div class="aetb-engraving-row-grid">' +
          '<label class="aetb-f"><span>Line 1</span><input type="text" maxlength="32" data-ae-row-field="line1" value="' + escapeHTML(old.line1 || "") + '" placeholder="Name / title"></label>' +
          '<label class="aetb-f"><span>Line 2</span><input type="text" maxlength="32" data-ae-row-field="line2" value="' + escapeHTML(old.line2 || "") + '" placeholder="Award / place"></label>' +
          '<label class="aetb-f"><span>Line 3</span><input type="text" maxlength="32" data-ae-row-field="line3" value="' + escapeHTML(old.line3 || "") + '" placeholder="Optional"></label>' +
        "</div>" +
        '<div class="aetb-row-plate" aria-label="Plate preview for trophy ' + i + '">' +
          '<span>Output</span>' +
          '<div class="aetb-mini-plate"><b data-ae-row-preview="line1"></b><em data-ae-row-preview="line2"></em><small data-ae-row-preview="line3"></small></div>' +
        "</div>" +
      "</div>";
    }
    mount.innerHTML = html;
    this.renderedEngravingCount = count;
    this.renderedEngravingMode = mode;
    this.syncRowPreviews();
  };
  Builder.prototype.buildEngravingPayload = function () {
    var mode = this.state.engravingMode === "different" ? "different" : "same";
    if (mode === "different") {
      return { mode: mode, rows: this.getEngravingRows().slice(0, Math.max(1, Number(this.state.count) || 1)) };
    }
    return { mode: mode, shared: this.sameEngravingFields() };
  };
  Builder.prototype.formatEngravingDetails = function (engraving) {
    if (!engraving) return "";
    if (engraving.mode !== "different") {
      var f = engraving.shared || {};
      return [f.line1, f.line2, f.line3].filter(Boolean).join(" / ");
    }
    return (engraving.rows || []).map(function (row) {
      var lines = [row.line1, row.line2, row.line3].filter(Boolean).join(" / ");
      return "Trophy " + row.trophy + ": " + (lines || "(blank)");
    }).join("; ");
  };
  Builder.prototype.syncRowPreviews = function () {
    var count = Math.max(this.minCount || 1, Number(this.state.count) || 1);
    var filled = 0;
    this.root.querySelectorAll("[data-ae-engraving-row]").forEach(function (row) {
      var get = function (field) {
        var input = row.querySelector('[data-ae-row-field="' + field + '"]');
        return input ? String(input.value || "").trim() : "";
      };
      var values = { line1: get("line1"), line2: get("line2"), line3: get("line3") };
      if (values.line1 || values.line2 || values.line3) filled += 1;
      row.classList.toggle("is-filled", Boolean(values.line1 || values.line2 || values.line3));
      ["line1", "line2", "line3"].forEach(function (field) {
        var node = row.querySelector('[data-ae-row-preview="' + field + '"]');
        if (!node) return;
        node.textContent = values[field] || (field === "line1" ? "Name / title" : field === "line2" ? "Award / place" : "");
        node.hidden = field === "line3" && !values[field];
      });
    });
    var progress = this.root.querySelector("[data-ae-engraving-progress]");
    if (progress) progress.textContent = filled + " of " + count + " filled - blank plates are okay.";
    this.syncCopyRowButton();
  };
  Builder.prototype.bindEngravingMode = function () {
    var self = this;
    this.root.addEventListener("change", function (e) {
      var input = e.target.closest("[data-ae-engraving-mode]");
      if (!input) return;
      self.state.engravingMode = input.value === "different" ? "different" : "same";
      self.renderedEngravingMode = null;
      self.update();
    });
  };
  Builder.prototype.setActiveEngravingRowFromTarget = function (target) {
    var row = target && target.closest && target.closest("[data-ae-engraving-row]");
    if (!row) return;
    var index = Number(row.getAttribute("data-ae-engraving-row"));
    if (isFinite(index) && index > 0) {
      this.activeEngravingRow = index;
      this.syncCopyRowButton();
    }
  };
  Builder.prototype.syncCopyRowButton = function () {
    var btn = this.root.querySelector("[data-ae-copy-row-button]");
    if (!btn) return;
    var rows = [].slice.call(this.root.querySelectorAll("[data-ae-engraving-row]"));
    var count = rows.length || Math.max(this.minCount || 1, Number(this.state.count) || 1);
    var active = Math.max(1, Math.min(Number(this.activeEngravingRow) || 1, count));
    this.activeEngravingRow = active;
    rows.forEach(function (row, index) {
      row.classList.toggle("is-active", index + 1 === active);
    });
    btn.textContent = "Copy row " + active + " down";
    btn.disabled = active >= count;
    btn.setAttribute("aria-label", active >= count
      ? "Row " + active + " is the last row"
      : "Copy trophy row " + active + " into every row below it");
  };
  Builder.prototype.bindEngravingTools = function () {
    var self = this;
    this.root.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-ae-engraving-action]");
      if (!btn) return;
      var action = btn.getAttribute("data-ae-engraving-action");
      var rows = [].slice.call(self.root.querySelectorAll("[data-ae-engraving-row]"));
      if (!rows.length) return;
      var valuesFrom = function (row) {
        var get = function (field) {
          var input = row.querySelector('[data-ae-row-field="' + field + '"]');
          return input ? String(input.value || "") : "";
        };
        return { line1: get("line1"), line2: get("line2"), line3: get("line3") };
      };
      var writeTo = function (row, values, fields) {
        fields.forEach(function (field) {
          var input = row.querySelector('[data-ae-row-field="' + field + '"]');
          if (input) input.value = values[field] || "";
        });
      };
      if (action === "copy-active-down") {
        var start = Math.max(0, Math.min((Number(self.activeEngravingRow) || 1) - 1, rows.length - 1));
        var source = rows[start];
        if (!source || start >= rows.length - 1) return;
        var sourceValues = valuesFrom(source);
        rows.slice(start + 1).forEach(function (row) { writeTo(row, sourceValues, ["line1", "line2", "line3"]); });
      }
      self.update();
    });
  };
  Builder.prototype.bindFields = function () {
    var self = this;
    ["input", "change"].forEach(function (ev) {
      self.root.addEventListener(ev, function (e) { if (e.target.matches("[data-ae-field],[data-ae-row-field]")) self.update(); });
    });
    ["focusin", "click"].forEach(function (ev) {
      self.root.addEventListener(ev, function (e) { self.setActiveEngravingRowFromTarget(e.target); });
    });
  };
  Builder.prototype.bindSpecialColumns = function () {
    var self = this;
    this.root.addEventListener("change", function (e) {
      var input = e.target.closest("[data-ae-special-column]");
      if (!input) return;
      self.state.specialColumnDesigns = Boolean(input.checked);
      self.update();
    });
  };
  Builder.prototype.syncSpecialColumns = function () {
    var requested = Boolean(this.state.specialColumnDesigns);
    var input = this.root.querySelector("[data-ae-special-column]");
    if (input && input.checked !== requested) input.checked = requested;
    var wrap = this.root.querySelector("[data-ae-special-column-details]");
    if (wrap) wrap.classList.toggle("on", requested);
    var status = this.root.querySelector("[data-ae-special-column-status]");
    if (status) status.textContent = requested ? "Requested" : "Optional";
  };
  Builder.prototype.bindHero = function () {
    var thumbs = this.root.querySelector("[data-ae-hero-thumbs]");
    var main = this.root.querySelector("[data-ae-hero-main]");
    if (!thumbs || !main) return;
    thumbs.addEventListener("click", function (e) {
      var span = e.target.closest("span");
      if (!span) return;
      thumbs.querySelectorAll("span").forEach(function (s) { s.classList.remove("on"); });
      span.classList.add("on");
      var img = span.querySelector("img");
      if (img) main.src = img.src;
    });
  };
  Builder.prototype.bindNav = function () {
    var links = [].slice.call(this.root.querySelectorAll(".aetb-links a"));
    var map = {};
    links.forEach(function (a) { map[a.getAttribute("href").slice(1)] = a; });
    if ("IntersectionObserver" in window) {
      var jumpSel = this.root.querySelector(".aetb-jump");
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            links.forEach(function (a) { a.classList.remove("on"); });
            if (map[en.target.id]) map[en.target.id].classList.add("on");
            if (jumpSel) jumpSel.value = en.target.id;
          }
        });
      }, { rootMargin: "-132px 0px -62% 0px", threshold: 0 });
      Object.keys(map).forEach(function (id) { var el = document.getElementById(id); if (el) io.observe(el); });
    }
    var sel = this.root.querySelector(".aetb-jump");
    if (sel) sel.addEventListener("change", function () {
      var el = document.getElementById(this.value); if (el) el.scrollIntoView();
    });
    var allow = !window.matchMedia || window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
    if (allow && "IntersectionObserver" in window) {
      this.root.classList.add("reveal-on");
      var targets = [].slice.call(this.root.querySelectorAll("[data-reveal]"));
      var ro = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); ro.unobserve(en.target); } });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.04 });
      targets.forEach(function (el) { ro.observe(el); });
    }
  };

  /* ---------- selection accessors ---------- */
  Builder.prototype.selected = function () {
    return {
      count: this.state.count,
      style: (function (sc, st) {
        if (!sc && !st) return null;
        var label = [sc && sc.label, st && st.label].filter(Boolean).join(" · ");
        return { label: label, handle: [sc && sc.handle, st && st.handle].filter(Boolean).join("+") };
      })(findById(this.styleColumns, this.state.styleColsId), findById(this.styleTiers, this.state.styleTiersId)),
      column: findById(this.columns, this.state.columnId),
      topper: findById(this.toppers, this.state.topperId),
      base: findById(this.bases, this.state.baseId)
    };
  };

  /* ---------- the main update pass ---------- */
  Builder.prototype.update = function () {
    var sel = this.selected();
    var cls = this.chosenClass(sel);
    this.state.chosenClass = cls;
    var variant = this.variantFor(this.state.count, this.state.styleColsId, this.state.styleTiersId, cls);
    this.state.variantId = variantAvailable(variant) ? String(variant.id) : "";
    this.renderQuantity();              // prices depend on style + class, so re-render the ladder
    this.syncSelectedClasses();
    this.updateHeads(sel);
    this.updateQuantityPanel(sel, variant, cls);
    this.updateClassLabel(cls);
    this.updateLogo(sel);
    this.syncSpecialColumns();
    this.renderEngravingRows();
    this.updatePlate();
    this.syncRowPreviews();
    this.updateVariantInput(variant);
    var payload = this.buildPayload(sel, cls);
    this.writeProperties(sel, payload);
    var staged = this.stagedPricing();
    this.renderSets(staged);
    this.updateSummary(sel, variant, cls, payload, staged);
    this.updateChrome(sel, variant, cls, staged);
    this.state.valid = Boolean(variantAvailable(variant) && sel.column && sel.topper && sel.base);
    this.updateSubmit();
  };

  Builder.prototype.syncSelectedClasses = function () {
    var state = this.state;
    this.root.querySelectorAll("[data-ae-select]").forEach(function (btn) {
      var key = btn.getAttribute("data-ae-select"), val = btn.getAttribute("data-ae-value");
      btn.classList.toggle("on", String(state[key]) === String(val));
    });
  };

  Builder.prototype.setText = function (sel, txt) {
    this.root.querySelectorAll(sel).forEach(function (n) { n.textContent = txt; });
  };

  Builder.prototype.countLabel = function (n) {
    return Number(n) === 1 ? "1 trophy" : n + " trophies";
  };

  Builder.prototype.updateHeads = function (sel) {
    this.setText("[data-ae-qty-head]", "— " + this.countLabel(sel.count));
    if (sel.style) this.setText("[data-ae-style-head]", "— " + sel.style.label);
    this.setText("[data-ae-col-head]", "— " + (sel.column ? displayComponentLabel(sel.column, "columns") : "Choose a color"));
    this.setText("[data-ae-top-head]", "— " + (sel.topper ? displayComponentLabel(sel.topper, "toppers") : "Choose a figure"));
    this.setText("[data-ae-base-head]", "— " + (sel.base ? displayComponentLabel(sel.base, "bases") : "Choose a base"));
  };

  Builder.prototype.updateQuantityPanel = function (sel, variant, cls) {
    var count = sel.count;
    var per = variant ? variant.price : null;     // per-trophy = variant price
    var total = (per != null) ? per * count : null;
    var tier = this.tierForCount(count);
    var save = this.tierSavePercent(tier);
    var disp = this.root.querySelector("[data-ae-count-input]");
    if (disp && document.activeElement !== disp) disp.value = count;
    var perNode = this.root.querySelector("[data-ae-qty-per]");
    if (perNode) perNode.innerHTML = (per != null ? escapeHTML(money(per, this.money)) : "—") + "<small>per trophy</small>";
    this.setText("[data-ae-qty-sub]", this.countLabel(count) + " · " + (total != null ? money(total, this.money) + " total" : "—") + (tier ? " · " + tier.variantValue + " tier" : ""));
    this.setText("[data-ae-qty-save]", save > 0 ? "Save " + save + "% tier" : "");
    var dec = this.root.querySelector('[data-ae-qty-step="-1"]');
    if (dec) dec.disabled = count <= this.minCount;
    // nudge to the next tier threshold
    var nudge = this.root.querySelector("[data-ae-qty-nudge]"), nt = this.root.querySelector("[data-ae-qty-nudge-text]");
    if (nudge && nt) {
      var idx = this.tiers.findIndex(function (t) { return tier && String(t.id) === String(tier.id); });
      var nextT = this.tiers[idx + 1];
      var nextPer = nextT ? this.perTrophyCents(nextT.min, cls) : null;
      if (nextT && nextPer != null && per != null && nextPer < per) {
        var add = Number(nextT.min) - Number(count);
        nt.innerHTML = "Add " + escapeHTML(add) + " more (" + escapeHTML(nextT.min) + "+) to drop to <b>" + escapeHTML(money(nextPer, this.money)) + "</b> each";
        nudge.hidden = false;
      } else { nudge.hidden = true; }
    }
  };

  // computed build class shown subtly; never a customer dial
  Builder.prototype.updateClassLabel = function (cls) {
    var label = capitalize(cls) + " build";
    this.setText("[data-ae-class-label]", label);
    var node = this.root.querySelector("[data-ae-class-label]");
    if (node) node.setAttribute("data-class", cls);
  };

  Builder.prototype.updatePlate = function () {
    var payload = this.buildEngravingPayload();
    var source = payload.mode === "different" ? (payload.rows[0] || {}) : (payload.shared || {});
    var l1 = source.line1 || "", l2 = source.line2 || "", l3 = source.line3 || "";
    var p1 = this.root.querySelector("[data-ae-plate-1]"), p2 = this.root.querySelector("[data-ae-plate-2]"), p3 = this.root.querySelector("[data-ae-plate-3]");
    if (p1) p1.textContent = l1 || "Your Event";
    if (p2) p2.textContent = l2 || "Your Team / Champions";
    if (p3) { if (l3) { p3.textContent = l3; p3.hidden = false; } else { p3.textContent = ""; p3.hidden = true; } }
    var note = this.root.querySelector("[data-ae-plate-note]");
    if (note) note.textContent = payload.mode === "different"
      ? "Previewing trophy 1. Every row is sent with the order."
      : "Live preview - actual plate layout is finalized by our shop.";
  };

  Builder.prototype.updateVariantInput = function (variant) {
    var idInput = this.root.querySelector('[name="id"]');
    if (idInput) idInput.value = variantAvailable(variant) ? variant.id : "";
    // hidden quantity input = the trophy count (so /cart/add buys `count` of a per-trophy variant)
    var qtyInput = this.root.querySelector('[name="quantity"]');
    if (qtyInput) qtyInput.value = this.state.count;
  };

  Builder.prototype.buildPayload = function (sel, cls) {
    var engraving = this.buildEngravingPayload();
    var f = engraving.mode === "different" ? { line1: "", line2: "", line3: "" } : engraving.shared;
    return {
      version: this.data.version,
      count: sel.count,
      priceClass: capitalize(cls),
      selections: {
        quantity: sel.count, style: sel.style && sel.style.label,
        column: sel.column && sel.column.label, topper: sel.topper && sel.topper.label, base: sel.base && sel.base.label
      },
      // _Component Handles carries the canonical component handles. The storefront only emits
      // customer-safe labels plus these handles; private catalog fields stay out of line properties.
      componentHandles: {
        style: sel.style && (sel.style.handle || sel.style.id), column: sel.column && (sel.column.handle || sel.column.id),
        topper: sel.topper && (sel.topper.handle || sel.topper.id), base: sel.base && (sel.base.handle || sel.base.id)
      },
      fields: f,
      specialColumnDesignsRequested: Boolean(this.state.specialColumnDesigns),
      engraving: engraving
    };
  };

  Builder.prototype.setProp = function (name, value) {
    var el = this.root.querySelector('[data-ae-property="' + name + '"]');
    if (el) {
      var hasValue = value != null && String(value) !== "";
      el.value = hasValue ? String(value) : "";
      if (el.hasAttribute("data-ae-optional-property")) el.disabled = !hasValue;
    }
  };
  Builder.prototype.setError = function (message) {
    var err = this.root.querySelector("[data-ae-error]");
    if (err) err.textContent = message || "";
  };

  Builder.prototype.propertiesForPayload = function (payload, meta) {
    payload = payload || {};
    var selections = payload.selections || {};
    var engraving = payload.engraving || {};
    var fields = payload.fields || {};
    var outgoing = JSON.parse(JSON.stringify(payload));
    var props = {};
    if (meta) {
      outgoing.multiSet = {
        setIndex: meta.setIndex,
        setCount: meta.setCount,
        aggregateQuantity: meta.aggregateQuantity,
        aggregateTier: meta.aggregateTier,
        aggregateSavePercent: meta.aggregateSavePercent || 0
      };
      props["Order Set"] = meta.setIndex + " of " + meta.setCount;
      props["Group Pricing"] = meta.aggregateQuantity + " trophies across " + meta.setCount + " sets - " + meta.aggregateTier + " tier";
      if (meta.aggregateSavePercent) props["Group Discount"] = "Save " + meta.aggregateSavePercent + "% tier";
    }
    props.Quantity = String(payload.count || selections.quantity || "");
    props.Style = selections.style || "";
    props["Price Class"] = payload.priceClass || "";
    props.Column = selections.column || "";
    props["Topper / Figure"] = selections.topper || "";
    props.Base = selections.base || "";
    if (payload.specialColumnDesignsRequested) props["Special Column Designs"] = "Requested - please reach out";
    props["Engraving Mode"] = engraving.mode === "different" ? "Different engraving per trophy" : "Same engraving on every trophy";
    props["Engraving Details"] = this.formatEngravingDetails(engraving);
    if (engraving.mode === "different") {
      props["Engraving Line 1"] = "Different engraving per trophy";
      props["Engraving Line 2"] = "See Engraving Details";
    } else {
      props["Engraving Line 1"] = fields.line1 || "";
      props["Engraving Line 2"] = fields.line2 || "";
      props["Engraving Line 3"] = fields.line3 || "";
    }
    props["_AE Builder Version"] = outgoing.version || "";
    props["_Component Handles"] = JSON.stringify(outgoing.componentHandles || {});
    props["_Builder Payload"] = JSON.stringify(outgoing);
    Object.keys(props).forEach(function (key) {
      if (props[key] == null || String(props[key]) === "") delete props[key];
      else props[key] = String(props[key]);
    });
    return props;
  };

  Builder.prototype.writeProperties = function (sel, payload) {
    var props = this.propertiesForPayload(payload);
    var self = this;
    [
      "Quantity", "Style", "Price Class", "Column", "Topper / Figure", "Base",
      "Special Column Designs", "Engraving Line 1", "Engraving Line 2", "Engraving Line 3",
      "Engraving Mode", "Engraving Details", "_AE Builder Version", "_Component Handles", "_Builder Payload"
    ].forEach(function (name) {
      self.setProp(name, props[name] || "");
    });
  };

  Builder.prototype.createSetSnapshot = function () {
    var sel = this.selected();
    var cls = this.chosenClass(sel);
    var variant = this.variantFor(sel.count, this.state.styleColsId, this.state.styleTiersId, cls);
    if (!variantAvailable(variant) || !sel.column || !sel.topper || !sel.base) return null;
    var payload = this.buildPayload(sel, cls);
    var engravingLabel = payload.engraving && payload.engraving.mode === "different"
      ? "Different engraving"
      : "Same engraving";
    return {
      id: "set-" + Date.now() + "-" + Math.random().toString(36).slice(2, 8),
      count: Number(sel.count),
      styleColsId: this.state.styleColsId,
      styleTiersId: this.state.styleTiersId,
      chosenClass: cls,
      payload: JSON.parse(JSON.stringify(payload)),
      labels: {
        style: sel.style && sel.style.label,
        column: sel.column && displayComponentLabel(sel.column, "columns"),
        topper: sel.topper && displayComponentLabel(sel.topper, "toppers"),
        base: sel.base && displayComponentLabel(sel.base, "bases"),
        engraving: engravingLabel
      }
    };
  };

  Builder.prototype.stagedPricing = function () {
    var self = this;
    var totalCount = this.sets.reduce(function (sum, set) { return sum + Number(set.count || 0); }, 0);
    if (!totalCount) return { totalCount: 0, totalCents: 0, savedCents: 0, lines: [], valid: false, tier: null };
    var tier = this.tierForCount(totalCount);
    var lines = this.sets.map(function (set) {
      var variant = self.variantFor(totalCount, set.styleColsId, set.styleTiersId, set.chosenClass);
      var single = self.variantFor(1, set.styleColsId, set.styleTiersId, set.chosenClass);
      var lineTotal = variant ? Number(variant.price || 0) * Number(set.count || 0) : null;
      var saved = variant && single && single.price > variant.price
        ? (Number(single.price) - Number(variant.price)) * Number(set.count || 0)
        : 0;
      return { set: set, variant: variant, lineTotal: lineTotal, savedCents: saved };
    });
    return {
      totalCount: totalCount,
      totalCents: lines.reduce(function (sum, line) { return sum + Number(line.lineTotal || 0); }, 0),
      savedCents: lines.reduce(function (sum, line) { return sum + Number(line.savedCents || 0); }, 0),
      lines: lines,
      valid: lines.length > 0 && lines.every(function (line) { return variantAvailable(line.variant); }),
      tier: tier,
      savePercent: this.tierSavePercent(tier)
    };
  };

  Builder.prototype.renderSets = function (pricing) {
    var panels = [].slice.call(this.root.querySelectorAll("[data-ae-set-panel]"));
    if (!panels.length) return;
    pricing = pricing || this.stagedPricing();
    var self = this;
    panels.forEach(function (panel) {
      var countNode = panel.querySelector("[data-ae-set-total]");
      var list = panel.querySelector("[data-ae-set-list]");
      var clear = panel.querySelector("[data-ae-clear-sets]");
      var add = panel.querySelector("[data-ae-add-set]");
      if (!self.sets.length) {
        if (countNode) countNode.textContent = "No saved sets yet";
        if (list) { list.hidden = true; list.innerHTML = ""; }
        if (clear) clear.hidden = true;
        if (add) add.textContent = "Save this setup";
        panel.classList.remove("has-sets");
        return;
      }
      panel.classList.add("has-sets");
      var tierText = pricing.tier ? pricing.tier.variantValue + " tier" : "group tier";
      if (countNode) countNode.textContent = self.countLabel(pricing.totalCount) + " saved - " + tierText;
      if (clear) clear.hidden = false;
      if (add) add.textContent = "Save another setup";
      if (list) {
        list.hidden = false;
        list.innerHTML = pricing.lines.map(function (line, index) {
        var set = line.set;
        var total = line.lineTotal != null ? money(line.lineTotal, self.money) : "Unavailable";
        return '<div class="aetb-set-row">' +
          '<span class="aetb-set-num">' + escapeHTML(index + 1) + '</span>' +
          '<span class="aetb-set-copy"><b>' + escapeHTML(set.count + " trophies - " + (set.labels.style || "Trophy set")) + '</b>' +
          '<small>' + escapeHTML([set.labels.topper, set.labels.base, set.labels.engraving].filter(Boolean).join(" - ")) + '</small></span>' +
          '<strong>' + escapeHTML(total) + '</strong>' +
          '<button type="button" data-ae-remove-set="' + escapeHTML(set.id) + '">Remove</button>' +
        '</div>';
        }).join("");
      }
    });
  };

  Builder.prototype.bindSets = function () {
    var self = this;
    this.root.addEventListener("click", function (e) {
      var add = e.target.closest("[data-ae-add-set]");
      var remove = e.target.closest("[data-ae-remove-set]");
      var clear = e.target.closest("[data-ae-clear-sets]");
      if (add) {
        self.update();
        if (!self.state.valid) {
          self.setError("Please complete this trophy set before saving it.");
          return;
        }
        var snapshot = self.createSetSnapshot();
        if (!snapshot) {
          self.setError("This trophy set is not available. Please adjust the style or components.");
          return;
        }
        self.sets.push(snapshot);
        self.setError("");
        self.update();
        return;
      }
      if (remove) {
        var id = remove.getAttribute("data-ae-remove-set");
        self.sets = self.sets.filter(function (set) { return String(set.id) !== String(id); });
        self.update();
        return;
      }
      if (clear) {
        self.sets = [];
        self.update();
      }
    });
  };

  Builder.prototype.logoSetRequiresNativeSubmit = function () {
    var handle = this.logoInsert && this.logoInsert.handle;
    if (!handle) return false;
    return this.sets.some(function (set) {
      return set.payload && set.payload.componentHandles && String(set.payload.componentHandles.topper) === String(handle);
    });
  };

  Builder.prototype.cartAddUrl = function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return root.replace(/\/?$/, "/") + "cart/add.js";
  };

  Builder.prototype.cartUrl = function () {
    return (this.data.settings && this.data.settings.cartUrl) || "/cart";
  };

  Builder.prototype.stagedCartItems = function (pricing) {
    var self = this;
    pricing = pricing || this.stagedPricing();
    var tier = pricing.tier;
    var metaBase = {
      setCount: this.sets.length,
      aggregateQuantity: pricing.totalCount,
      aggregateTier: tier ? tier.variantValue : "",
      aggregateSavePercent: pricing.savePercent || 0
    };
    return pricing.lines.map(function (line, index) {
      var meta = Object.assign({}, metaBase, { setIndex: index + 1 });
      return {
        id: Number(line.variant.id),
        quantity: Number(line.set.count || 1),
        properties: self.propertiesForPayload(line.set.payload, meta)
      };
    });
  };

  Builder.prototype.submitStagedSets = function () {
    var self = this;
    var pricing = this.stagedPricing();
    if (!pricing.valid) {
      this.setError("One saved trophy set cannot resolve to the combined quantity tier. Please remove it and save it again.");
      return;
    }
    if (this.logoSetRequiresNativeSubmit()) {
      this.setError("Custom logo upload sets need to be added one at a time so Shopify can attach the artwork file.");
      return;
    }
    if (this.submittingSets) return;
    this.submittingSets = true;
    this.updateSubmit();
    fetch(this.cartAddUrl(), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: this.stagedCartItems(pricing) })
    }).then(function (res) {
      if (!res.ok) throw new Error("Cart add failed");
      return res.json();
    }).then(function () {
      window.location.href = self.cartUrl();
    }).catch(function () {
      self.submittingSets = false;
      self.setError("We could not add the saved sets to cart. Please try again.");
      self.updateSubmit();
    });
  };

  Builder.prototype.updateBeforeTotal = function (cents) {
    var node = this.root.querySelector("[data-ae-before-total]");
    if (!node) return;
    var amount = node.querySelector("s") || node;
    if (cents != null && Number(cents) > 0) {
      amount.textContent = money(cents, this.money);
      node.hidden = false;
    } else {
      amount.textContent = "";
      node.hidden = true;
    }
  };

  Builder.prototype.updateSummary = function (sel, variant, cls, payload, staged) {
    staged = staged || this.stagedPricing();
    if (this.sets.length) {
      var stagedBuild = this.root.querySelector("[data-ae-summary]");
      if (stagedBuild) {
        var rows = [
          ["Saved sets", this.sets.length + " sets"],
          ["Total quantity", this.countLabel(staged.totalCount)],
          ["Group pricing", staged.tier ? staged.tier.variantValue + " tier" : "Unavailable"],
          ["Discount label", staged.savePercent ? "Save " + staged.savePercent + "%" : "None"]
        ];
        stagedBuild.innerHTML = rows.map(function (r) {
          return "<div><dt>" + escapeHTML(r[0]) + "</dt><dd>" + escapeHTML(r[1] || "-") + "</dd></div>";
        }).join("");
      }
      var stagedPriceRows = this.root.querySelector("[data-ae-summary-price]");
      if (stagedPriceRows) {
        var html = "<div><dt>Combined order</dt><dd>" + escapeHTML(this.countLabel(staged.totalCount)) + "</dd></div>";
        if (staged.savedCents > 0) {
          html += '<div class="save"><dt>Bulk savings</dt><dd>-' + escapeHTML(money(staged.savedCents, this.money)) + "</dd></div>";
        }
        stagedPriceRows.innerHTML = html;
      }
      var stagedPrice = this.root.querySelector("[data-ae-price]");
      if (stagedPrice) stagedPrice.textContent = money(staged.totalCents, this.money);
      this.updateBeforeTotal(staged.savedCents > 0 ? staged.totalCents + staged.savedCents : null);
      this.setText("[data-ae-totsub]", this.sets.length + " sets - " + this.countLabel(staged.totalCount) + (staged.tier ? " - " + staged.tier.variantValue + " tier" : ""));
      return;
    }
    var build = this.root.querySelector("[data-ae-summary]");
    if (build) {
      var engravingLabel = payload && payload.engraving && payload.engraving.mode === "different" ? "Different per trophy" : "Same on every trophy";
      var rows = [
        ["Quantity", this.countLabel(sel.count)],
        ["Style", sel.style && sel.style.label],
        ["Build", capitalize(cls)],
        ["Column", sel.column && displayComponentLabel(sel.column, "columns")],
        ["Topper", sel.topper && displayComponentLabel(sel.topper, "toppers")],
        ["Base", sel.base && displayComponentLabel(sel.base, "bases")],
        ["Engraving", engravingLabel]
      ];
      if (payload && payload.specialColumnDesignsRequested) rows.push(["Special columns", "Contact requested"]);
      build.innerHTML = rows.map(function (r) {
        return "<div><dt>" + escapeHTML(r[0]) + "</dt><dd>" + escapeHTML(r[1] || "—") + "</dd></div>";
      }).join("");
    }
    var per = variant ? variant.price : null;
    var single = this.singlePerTrophy(cls);
    var pr = this.root.querySelector("[data-ae-summary-price]");
    var beforeTotal = null;
    if (pr) {
      var html = "<div><dt>Per trophy</dt><dd>" + (per != null ? escapeHTML(money(per, this.money)) : "—") + "</dd></div>";
      if (per != null && single && single > per) {
        var savedTotal = (single - per) * Number(sel.count);
        beforeTotal = single * Number(sel.count);
        html += '<div class="save"><dt>Bulk savings</dt><dd>−' + escapeHTML(money(savedTotal, this.money)) + "</dd></div>";
      }
      pr.innerHTML = html;
    }
    var total = (per != null) ? per * Number(sel.count) : null;
    var priceNode = this.root.querySelector("[data-ae-price]");
    if (priceNode) priceNode.textContent = total != null ? money(total, this.money) : "Get a quote";
    this.updateBeforeTotal(beforeTotal);
    this.setText("[data-ae-totsub]", (variant && per != null)
      ? this.countLabel(sel.count) + " · " + money(per, this.money) + " each · free engraving"
      : "Free engraving & setup");
  };

  Builder.prototype.updateChrome = function (sel, variant, cls, staged) {
    staged = staged || this.stagedPricing();
    if (this.sets.length) {
      var stagedBuildTxt = this.sets.length + " sets - " + this.countLabel(staged.totalCount);
      var stagedPriceTxt = money(staged.totalCents, this.money);
      var stagedBarBuild = this.root.querySelector("[data-ae-bar-build]");
      if (stagedBarBuild) stagedBarBuild.innerHTML = escapeHTML(stagedBuildTxt) + ' <em>- ' + escapeHTML(stagedPriceTxt) + "</em>";
      this.setText("[data-ae-dock-build]", stagedBuildTxt);
      this.setText("[data-ae-dock-price]", stagedPriceTxt);
      this.setText("[data-ae-hero-price]", stagedPriceTxt);
      this.setText("[data-ae-hero-pnote]", this.countLabel(staged.totalCount) + " across " + this.sets.length + " sets");
      return;
    }
    var buildTxt = (sel.style ? sel.style.label : "") + " · " + sel.count;
    var per = variant ? variant.price : null;
    var total = (per != null) ? per * Number(sel.count) : null;
    var priceTxt = total != null ? money(total, this.money) : "Get a quote";
    var barBuild = this.root.querySelector("[data-ae-bar-build]");
    if (barBuild) barBuild.innerHTML = escapeHTML(buildTxt) + ' <em>· ' + escapeHTML(priceTxt) + "</em>";
    this.setText("[data-ae-dock-build]", buildTxt);
    this.setText("[data-ae-dock-price]", priceTxt);
    this.setText("[data-ae-hero-price]", priceTxt);
    if (per != null) {
      this.setText("[data-ae-hero-pnote]", money(per, this.money) + " per trophy · " + this.countLabel(sel.count));
    }
  };

  Builder.prototype.updateSubmit = function () {
    if (this.sets.length) {
      var pricing = this.stagedPricing();
      var setEnabled = pricing.valid && !this.submittingSets;
      this.root.querySelectorAll("[data-ae-submit],[data-ae-bar-submit],[data-ae-dock-submit]").forEach(function (b) {
        b.disabled = !setEnabled;
        b.textContent = this.submittingSets ? "Adding Sets..." : "Add " + this.sets.length + " Sets to Cart";
      }, this);
      if (setEnabled) this.setError("");
      return;
    }
    var enabled = this.state.valid;
    this.root.querySelectorAll("[data-ae-submit],[data-ae-bar-submit],[data-ae-dock-submit]").forEach(function (b) {
      b.disabled = !enabled;
    });
    var sub = this.root.querySelector("[data-ae-submit]");
    if (sub) sub.textContent = "Add to Cart";
    if (enabled) this.setError("");
  };

  Builder.prototype.bindSubmit = function () {
    if (!this.form) return;
    var self = this;
    this.form.addEventListener("submit", function (e) {
      self.update();
      if (self.sets.length) {
        e.preventDefault();
        self.submitStagedSets();
        return;
      }
      if (!self.state.valid) {
        e.preventDefault();
        self.setError("Please complete the required trophy details before checkout.");
      }
    });
  };

  function init() {
    document.querySelectorAll("[data-ae-trophy-builder]").forEach(function (root) {
      if (root.__aeTrophyBuilder || root.__aeTrophyBuilderLoading) return;
      root.__aeTrophyBuilderLoading = true;
      var data = parseData(root);
      fetchCatalogForData(data).then(function (catalog) {
        if (catalog) applyCatalogData(data, catalog);
        root.__aeTrophyBuilder = new Builder(root, data);
      }).catch(function () {
        root.__aeTrophyBuilder = new Builder(root, data);
      }).then(function () {
        root.__aeTrophyBuilderLoading = false;
      });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
